import {
    SAVE_ONBOARDING_STEP,
    SAVE_ONBOARDING_SUCCESS,
    SAVE_ONBOARDING_FAILED,
    FETCH_MATCHING_PROFILES,
    FETCH_MATCHING_PROFILES_SUCCESS,
    FETCH_MATCHING_PROFILES_FAILED,
    USER_SELECTED_PROFILE,
    GET_RATED_DECREMENT_STEP,
    GET_RATED_INCREMENT_STEP,
    GET_RATED_RESET_STEPS,
} from './actionTypes/onboarding-action-types';
import { getProfileMaches } from '../api';
import { showErrorPopup } from './notification-actions';

export const createNewProfile = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: SAVE_ONBOARDING_STEP,
    });
    try {
        const res = await mainApi.post('v1/account/create-player',
            data);
        dispatch({
            type: SAVE_ONBOARDING_SUCCESS,
            payload: res,
        });
    } catch (err) {
        const errText = err.response ? err.response.data : 'Error communicating with server';
        dispatch({
            type: SAVE_ONBOARDING_FAILED,
            message: errText,
        });
        dispatch(showErrorPopup({
            message: 'Error creating profile',
            error: errText,
        }));
    }
};

export const claimSelectedPlayer = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: SAVE_ONBOARDING_STEP,
    });
    try {
        const res = await mainApi.post('v1/account/claim',
            data);
        dispatch({
            type: SAVE_ONBOARDING_SUCCESS,
            payload: res,
        });
    } catch (err) {
        const errText = err.response ? err.response.data : 'Error communicating with server';
        dispatch({
            type: SAVE_ONBOARDING_FAILED,
            message: errText,
        });
        dispatch(showErrorPopup({
            message: 'Error claiming player',
            error: errText,
        }));
    }
};

export const fetchMatchingProfiles = (firstName, lastName) => async (dispatch, getState, { mainApi }) => {
    const { auth } = getState();
    if (auth.user.firstName && auth.user.lastName) {
        const { gender } = auth.user;
        const year = 2017; // TODO: hardcoded record year
        dispatch({
            type: FETCH_MATCHING_PROFILES,
        });
        try {
            const res = await getProfileMaches(mainApi, {
                firstName: firstName || auth.user.firstName,
                lastName: lastName || auth.user.lastName,
                gender,
                year,
            });
            dispatch({
                type: FETCH_MATCHING_PROFILES_SUCCESS,
                payload: res,
            });
        } catch (err) {
            dispatch({ type: FETCH_MATCHING_PROFILES_FAILED });
        }
    } else {
        dispatch({ type: FETCH_MATCHING_PROFILES_FAILED });
    }
};

export const fetchMatchingProfilesById = (id) => async (dispatch, getState, { mainApi }) => {
    console.log('fetchMatchingProfilesById');
    const year = 2017; // TODO: hardcoded record year
    dispatch({
        type: FETCH_MATCHING_PROFILES,
    });
    try {
        const res = await getProfileMaches(mainApi, {
            id,
            year,
        });
        console.log('fetchMatchingProfilesById res', res);
        dispatch({
            type: FETCH_MATCHING_PROFILES_SUCCESS,
            payload: res,
        });
    } catch (err) {
        dispatch({ type: FETCH_MATCHING_PROFILES_FAILED });
    }
};

export const userSelectedProfile = profile => {
    return ({
        type: USER_SELECTED_PROFILE,
        profile,
    });
};

export const getRatedIncrementStep = () => {
    return ({
        type: GET_RATED_INCREMENT_STEP,
    });
};

export const getRatedDecrementStep = () => {
    return ({
        type: GET_RATED_DECREMENT_STEP,
    });
};

export const getRatedResetSteps = () => {
    return ({
        type: GET_RATED_RESET_STEPS,
    });
};
